import { Toaster as Sonner, type ToasterProps } from "sonner";

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      // "system" tracks prefers-color-scheme, the same signal that flips the
      // app tokens (there is no manual theme toggle). Revisit if one is added.
      theme="system"
      className="toaster group"
      // Sonner injects an unlayered stylesheet that beats Tailwind's layered
      // utilities, so theming must go through sonner's own CSS variables.
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
